"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      d: "M9.618 4.474c-.072-.16-.227-.264-.4-.27H7.11l.584-2.14c.038-.136.008-.282-.08-.393-.087-.11-.22-.175-.362-.175h-3.22c-.212-.008-.403.13-.46.334L2.338 6.34c-.038.135-.008.282.078.392.088.112.224.178.368.176h1.78l-.832 3.04c-.055.204.038.42.224.518.187.1.42.06.563-.097l5.014-5.414c.122-.13.156-.32.085-.482h-.002zM5.112 8.39l.493-1.804c.037-.137.008-.282-.08-.393-.087-.11-.22-.176-.363-.176H3.397l.984-3.62H6.65l-.584 2.14c-.037.137-.006.286.085.397.09.113.23.177.376.172h1.64L5.113 8.39z",
      fill: "currentColor",
      fillRule: "nonzero"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Flash.js.map